/* ============================================================
   Home Wellbeinn — interacciones compartidas de las secciones uxkid-home-*
   Vanilla JS, sin dependencias. Es un subconjunto de assets/balance-pdp.js
   (Home no usa el bottom sheet ni el sticky CTA de la PDP, que se dejan
   fuera para no cargar código muerto): solo lo que hero/features/products
   necesitan.
   Comportamientos:
   - Carruseles con scroll-snap + dots sincronizados ([data-b-carousel])
   - Flechas prev/next de carrusel ([data-b-prev]/[data-b-next])
   - Tabs de la sección features ([data-b-tab] filtra [data-b-tab-panel])
   - Add to cart AJAX del carrusel de productos ([data-b-atc])
   ============================================================ */
(function () {
  'use strict';

  // Guard de idempotencia: cada sección uxkid-home-* imprime este script y el
  // navegador ejecuta cada etiqueta; sin esto los listeners se duplican (el
  // add to cart agregaría el producto varias veces).
  if (window.__uxkidHomeBaseLoaded) return;
  window.__uxkidHomeBaseLoaded = true;

  /**
   * Sincroniza los dots con la posición de scroll de un carrusel y cablea
   * las flechas prev/next.
   * Input: root (Element) — contenedor con [data-b-carousel] y, opcional,
   *   un [data-b-dots] hermano.
   * Output: ninguno (efectos secundarios sobre el DOM del root).
   */
  function initCarousel(root) {
    try {
      var track = root.querySelector('[data-b-carousel]');
      var dotsWrap = root.querySelector('[data-b-dots]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (dotsWrap && !dotsWrap.children.length) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { scrollToSlide(i); });
          dotsWrap.appendChild(b);
        });
      }

      function scrollToSlide(i) {
        var el = slides[i];
        if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function activeIndex() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (el, i) {
          var mid = el.offsetLeft - track.offsetLeft + el.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function update() {
        var idx = activeIndex();
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }
        root.dispatchEvent(new CustomEvent('uxkid:slide', { detail: { index: idx } }));
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () { update(); ticking = false; });
        }
      });
      update();

      root.querySelectorAll('[data-b-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () { scrollToSlide(Math.max(0, activeIndex() - 1)); });
      });
      root.querySelectorAll('[data-b-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { scrollToSlide(Math.min(slides.length - 1, activeIndex() + 1)); });
      });
    } catch (err) {
      // No romper el resto de la página si un carrusel puntual falla al inicializar.
      if (window.console && console.warn) console.warn('[uxkid-home] initCarousel:', err);
    }
  }

  /**
   * Tabs de la sección features: muestra solo las cards del tab activo.
   * Input: root (Element) — contenedor con [data-b-tab] y [data-b-tab-panel].
   * Output: ninguno.
   */
  function initTabs(root) {
    try {
      var tabs = root.querySelectorAll('[data-b-tab]');
      if (!tabs.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-b-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          root.querySelectorAll('[data-b-tab-panel]').forEach(function (card) {
            card.hidden = card.getAttribute('data-b-tab-panel') !== key;
          });
          var track = root.querySelector('[data-b-carousel]');
          if (track) track.scrollTo({ left: 0 });
        });
      });
    } catch (err) {
      if (window.console && console.warn) console.warn('[uxkid-home] initTabs:', err);
    }
  }

  /**
   * Add to cart AJAX. Input: form (HTMLFormElement) con [data-b-atc].
   * Efecto: agrega el item al carrito de Shopify y abre el drawer del tema
   * si existe; si no, redirige a /cart. En error, redirige a /cart para que
   * Shopify muestre el mensaje (ej. sin stock).
   */
  function initAtc(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_error');
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawerToggle = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"][data-drawer]');
          if (drawerToggle) { drawerToggle.click(); } else { window.location.href = '/cart'; }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-b-carousel-root]').forEach(initCarousel);
    document.querySelectorAll('[data-b-tabs-root]').forEach(initTabs);
    document.querySelectorAll('form[data-b-atc]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
